export var GenderEnum;
(function (GenderEnum) {
    GenderEnum["Male"] = "Male";
    GenderEnum["Female"] = "Female";
})(GenderEnum || (GenderEnum = {}));
